// Action Types
export const FETCH_NEW_PROJECTS_REQUEST = "FETCH_NEW_PROJECTS_REQUEST";
export const FETCH_NEW_PROJECTS_SUCCESS = "FETCH_NEW_PROJECTS_SUCCESS";
export const FETCH_NEW_PROJECTS_FAILURE = "FETCH_NEW_PROJECTS_FAILURE";

// Action Creators
export const fetchNewProjectRequest = (ticker) => {
return (dispatch) => {
  dispatch({
    type: FETCH_NEW_PROJECTS_REQUEST,
    payload: ticker,
  });
};
};
export const fetchNewProjectSuccess = (data) => ({
  type: FETCH_NEW_PROJECTS_SUCCESS,
  payload: data,
});
export const fetchNewProjectFailure = (error) => ({
  type: FETCH_NEW_PROJECTS_FAILURE,
  payload: error,
});
